import React, {FC} from 'react';
import cn from 'classnames';
import {Tooltip, TooltipProps} from '@/common/components/Tooltip';
import styles from './InfoIcon.css';

type InfoIconProps = TooltipProps;

export const InfoIcon: FC<InfoIconProps> = props => {
	const {className, title, ...proxyProps} = props;

	return (
		<Tooltip
			className={cn(styles.root, className)}
			title={<span className={styles.title}>{title}</span>}
			{...proxyProps}
		/>
	);
};

InfoIcon.displayName = 'InfoIcon';
